module.exports = __webpack_public_path__ + "img/baptist-logo.1e1ebc97.jpg";